<template>
  <div class="table-responsive">
    <table class="table table-hover">
      <thead>
      <tr>
        <th>{{'status' | translate($parent.$parent.language)}}</th>
        <th>{{'reservation_number' | translate($parent.$parent.language)}}</th>
        <th>{{'date' | translate($parent.$parent.language)}}</th>
        <th>{{'amount' | translate}}</th>
        <th>{{'client' | translate($parent.$parent.language)}} </th>
        <th>{{'handler' | translate($parent.$parent.language)}} </th>
        <th>{{'action' | translate($parent.$parent.language)}} </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="order, index in orders">
        <td>
          <span :class="order.status.style"><i :class="order.status.icon"></i>{{order.status.label}}</span>
        </td>
        <td>{{order.reservation_id}}</td>
        <td>{{order.date_order | orderDate}}<br><small class="text-muted">{{order.date_order | orderDate(true)}}</small></td>
        <td>{{order.products_price | currency}}<br><small class="text-muted">1 {{'items' | translate($parent.$parent.language)}}</small></td>
        <td>{{order.customer_firstname }} {{order.customer_name}}</td>
        <td>{{order.store_information}}<br><small class="text-muted">{{'store' | translate}}: {{order.store_number}}</small></td>
        <td>
          <router-link :to="'/click-and-collect/'+order.reservation_id"><b-btn class="btn btn-info btn-sm"><i class="fa fa-edit mr-5"></i>{{'edit' | translate($parent.$parent.language)}}</b-btn></router-link>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
module.exports = {
  props: ['orders'],
  data () {
    return {
      sortClass: window.localStorage.getItem('sortType') ? window.localStorage.getItem('sortType') === 'asc' : false
    }
  },
  methods: {
    sort () {
      this.sortClass = !this.sortClass
      this.$emit('sort', this.sortClass ? 'asc' : 'desc')
    }
  },
  watch: {
    model () {
      this.orders = []
    }
  }
}
</script>
<style>
  .sortable:hover {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/tools/Tables/ClickCollectTableComponent.vue